import React, { useEffect } from 'react';
import { useAuth } from '../../components/navigation/AuthenticationStateManager';
import NavigationTabBar from '../../components/navigation/NavigationTabBar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturedCourses from './components/FeaturedCourses';
import TestimonialsSection from './components/TestimonialsSection';
import PlatformFeatures from './components/PlatformFeatures';
import FooterSection from '../../components/navigation/FooterSection';
import BootcampPromoSection from "./components/BootcampPromoSection";

const HomeLanding = () => {
  const { isAuthenticated } = useAuth();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <NavigationTabBar isAuthenticated={isAuthenticated} />
      
      <main className="pt-16">
        <HeroSection />
        <BootcampPromoSection />
        <StatsSection />
        <FeaturedCourses />
        <TestimonialsSection />
        <PlatformFeatures />
      </main>

      <FooterSection />
    </div>
  );
};

export default HomeLanding;